import(/* webpackMode: "eager", webpackExports: ["AuthContextWrapper"] */ "/var/www/deemcee-frontend/context/userContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/var/www/deemcee-frontend/lib/firebase/NotificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Serif\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font-ibm-plex-serif\"}],\"variableName\":\"ibmPlexSerif\"}");
;
import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/deemcee-frontend/src/components/GlobalErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/deemcee-frontend/src/components/HistoryGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/deemcee-frontend/src/components/InstallAppGuide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/deemcee-frontend/src/components/theme/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/deemcee-frontend/src/components/ui/toaster.tsx");
